import styled from 'styled-components';
import { variableFont } from 'styles/theme';

export const ProductDescription = ({ text }) => (
  <ProductDescription.Wrapper data-qa="product_description">{text}</ProductDescription.Wrapper>
);

ProductDescription.Wrapper = styled.p`
  ${variableFont({ fontWeight: '400', size: '11px', height: '14px' })}
  margin: 24px 16px 60px 16px;
`;
